import { Box } from '@mui/material';

import styles from './businessItemMobile.module.css';

export interface FeatureItemProps {
  businessImgUrl: string;
  year?: string;
  title: string[];
  width?: string;
}

export default function BusinessItemMobile(props: FeatureItemProps) {
  return (
    <Box className={'business-item-mobile'}>
      <div className="business-item-content-wrap">
        <Box
          component={'div'}
          sx={{
            display: 'flex',
            padding: '0.625rem',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '0.625rem',
          }}
        >
          <img
            src={props.businessImgUrl}
            alt="사업 배너"
            style={{
              display: 'block', // 여백 없이 정렬
              width: 'auto', // ← 핵심 부분
              height: '32px',
              // width: '92px',
              maxWidth: '156px', // 필요 시 제한
              // padding: '8px'
            }}
          />
        </Box>
        <div className="business-item-mobile-year-wrap">
          <div className="year">{props.year}년</div>
        </div>
        <div className="business-item-mobile-title-wrap">
          <div className="title">
            {props.title.map((line, idx) => (
              <div key={idx}>{line}</div>
            ))}
          </div>
        </div>
      </div>
    </Box>
  );
}
